export default "__VITE_ASSET__BcmGdylo__"